<template>
  <!-- dropdown ที่คุมเองทั้งหมด (ไม่พึ่ง b-dropdown/Popper ของ BootstrapVue)
       @click.stop กันไม่ให้ event ทะลุไปโดน @click ของการ์ด (goCourse) -->
  <div :class="['share-button', { 'share-button--float': float }]" @click.stop>
    <!-- ปุ่มวงกลม (shape เป็น inline style กันเพี้ยนตอน SPA re-render) -->
    <button
      type="button"
      class="share-trigger"
      title="แชร์"
      aria-label="แชร์"
      :aria-expanded="open ? 'true' : 'false'"
      style="
        width: 34px;
        height: 34px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        padding: 0;
        border: none;
        flex: 0 0 auto;
        cursor: pointer;
      "
      @click="toggle"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
        <path d="M13.5 1a2.5 2.5 0 0 0-2.45 3.005L5.99 6.53a2.5 2.5 0 1 0 0 2.94l5.06 2.525a2.5 2.5 0 1 0 .67-1.34L6.66 8.13a2.51 2.51 0 0 0 0-.26l5.06-2.525A2.5 2.5 0 1 0 13.5 1Z"/>
      </svg>
    </button>

    <!-- เมนูแชร์ -->
    <div v-if="open" class="share-menu">
      <button type="button" class="share-item" @click="share('facebook')">
        <span class="brand-icon" style="color: #1877f2">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z"/>
          </svg>
        </span>
        Facebook
      </button>

      <button type="button" class="share-item" @click="share('x')">
        <span class="brand-icon" style="color: #000000">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"/>
          </svg>
        </span>
        X (Twitter)
      </button>

      <button type="button" class="share-item" @click="share('line')">
        <span class="brand-icon" style="color: #06c755">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.346 0 .627.285.627.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596a.633.633 0 0 1-.199.031.626.626 0 0 1-.51-.257l-2.443-3.325v2.955a.63.63 0 0 1-.628.629.63.63 0 0 1-.63-.629V8.108c0-.27.173-.51.43-.595a.643.643 0 0 1 .199-.031c.176 0 .347.088.451.257l2.461 3.316V8.108a.63.63 0 0 1 .63-.63.63.63 0 0 1 .63.63v4.771zm-5.741 0a.63.63 0 0 1-.631.629.63.63 0 0 1-.627-.629V8.108a.63.63 0 0 1 .63-.63.63.63 0 0 1 .628.63v4.771zm-2.466.629H4.917a.634.634 0 0 1-.63-.629V8.108a.63.63 0 0 1 .63-.63.63.63 0 0 1 .627.63v4.141h1.756a.63.63 0 0 1 .629.63c0 .344-.282.628-.629.628M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314"/>
          </svg>
        </span>
        LINE
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShareButton",
  props: {
    // URL ที่จะแชร์ (ถ้าไม่ส่งมา จะใช้ URL ของหน้าปัจจุบัน)
    url: { type: String, default: null },
    // id ของคอร์ส/subject สำหรับเก็บสถิติ
    subjectId: { type: [String, Number], default: null },
    // ข้อความ/หัวข้อประกอบการแชร์ (ใช้กับ X)
    title: { type: String, default: "" },
    // true = จัดวางลอยมุมขวาบนของ parent (parent ต้อง position: relative)
    float: { type: Boolean, default: true },
  },
  data() {
    return {
      open: false,
    };
  },
  computed: {
    shareUrl() {
      return this.url || window.location.href;
    },
  },
  beforeDestroy() {
    document.removeEventListener("click", this.onDocumentClick);
  },
  methods: {
    toggle() {
      this.open ? this.close() : this.openMenu();
    },
    openMenu() {
      this.open = true;
      // ปิดเมนูเมื่อคลิกที่อื่น
      document.addEventListener("click", this.onDocumentClick);
    },
    close() {
      this.open = false;
      document.removeEventListener("click", this.onDocumentClick);
    },
    onDocumentClick(e) {
      // คลิกนอก component → ปิด (คลิกในตัว component ถูก @click.stop กันไว้แล้ว)
      if (!this.$el.contains(e.target)) {
        this.close();
      }
    },
    share(platform) {
      const url = encodeURIComponent(this.shareUrl);
      const text = encodeURIComponent(this.title || "");
      let shareLink = "";

      switch (platform) {
        case "facebook":
          shareLink = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
          break;
        case "x":
          shareLink = `https://twitter.com/intent/tweet?url=${url}&text=${text}`;
          break;
        case "line":
          shareLink = `https://social-plugins.line.me/lineit/share?url=${url}`;
          break;
        default:
          return;
      }

      // เก็บสถิติแบบ fire-and-forget (ไม่บล็อกการเปิดหน้าต่างแชร์)
      this.recordShareStat(platform);

      window.open(shareLink, "_blank", "noopener,noreferrer,width=600,height=550");
      this.close();
    },

    async recordShareStat(platform) {
      try {
        await this.$store.dispatch("Share/recordShare", {
          // TODO: ปรับ payload ให้ตรงกับที่ backend กำหนด (รอ API/payload จากผู้ใช้)
          subject_id: this.subjectId,
          platform, // 'facebook' | 'x' | 'line'
          url: this.shareUrl,
        });
      } catch (e) {
        // ไม่ให้ error ของ stat กระทบ UX การแชร์
        console.error("record share stat error", e);
      }
    },
  },
};
</script>

<style scoped>
.share-button {
  display: inline-block;
}

.share-button--float {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 3;
}

/* วงกลมปุ่มแชร์ — shape อยู่ใน inline style แล้ว (กันหลุดตอน SPA re-render);
   ตรงนี้เหลือแค่ส่วน cosmetic (สี/เงา) */
.share-trigger {
  background-color: #ffffff;
  color: #135193;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.share-trigger:hover,
.share-trigger:focus {
  background-color: #135193;
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(19, 81, 147, 0.5);
  outline: none;
}

.share-menu {
  position: absolute;
  top: 42px;
  right: 0;
  min-width: 170px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 6px 0;
  z-index: 1000;
}

.share-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 16px;
  background: none;
  border: none;
  text-align: left;
  font-size: 14px;
  color: #212529;
  cursor: pointer;
}

.share-item:hover {
  background-color: #f2f4f7;
}

.brand-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  margin-right: 8px;
  vertical-align: middle;
}
</style>
